module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "padding-top": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "35px",
      "font-weight": "bold"
    }
  }, [_vm._v("Email Scheduler Logs")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Enter the email id to search:\n\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Minimum 5 characters"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary get-logs",
    class: {
      'disabled': _vm.searchTerm.trim().length < 5
    },
    on: {
      "click": function($event) {
        _vm.getLogs()
      }
    }
  }, [_vm._v("Get Logs")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Email Id")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', [_vm._v("Email Type")]), _vm._v(" "), _c('th', [_vm._v("Log Description")]), _vm._v(" "), _c('th', [_vm._v("Date-Time")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logsArr), function(i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i.emailId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.statusCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.actionDate))])])
  }))]), _vm._v(" "), (_vm.logsArr.length === 0 && !_vm.emptyLogs) ? _c('div', [_vm._v("Kindly enter the email id and search.")]) : _vm._e(), _vm._v(" "), (_vm.emptyLogs) ? _c('div', [_vm._v("No logs found. ")]) : _vm._e()])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-84feda02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84feda02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/SystemLogs.vue
// module id = 703
// module chunks = 1